var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStop = function SvgIconStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.875 5.875v12.25h12.25V5.875zm-2-.353c0-.91.737-1.647 1.647-1.647h12.956c.91 0 1.647.737 1.647 1.647v12.956c0 .91-.737 1.647-1.647 1.647H5.522c-.91 0-1.647-.737-1.647-1.647z",
    clipRule: "evenodd"
  })));
};
export default SvgIconStop;